module.exports = __webpack_public_path__ + "img/sprite-flag.b583c34.png";